var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.class !== undefined && _vm.item.class.includes('custom'))?_c('div',{class:_vm.item.class,style:(_vm.item.style)},[_c('span',[_vm._v("\n    "+_vm._s(_vm.item.values)+"\n  ")])]):_c('span',{class:_vm.item.class,style:(_vm.item.style)},[_vm._v("\n  "+_vm._s(_vm.item.values)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }